import React, { Component } from 'react'
import Card from '../cards/card'
import CardContainer from '../card-container/cardContainer'
import CardHolder from '../../card-holder/cardHolder'
import ResultBanner from './result-banner'
import queryString from 'query-string'
import { getCall, baseUrl } from '../../../../../helpers/api'
import resim from './Resim1.png'

class ResultCardsExample extends Component {

    constructor(props) {
        super(props)
        this.state = {
            multiple: true,
            bannerMargin: undefined,
            motherInfo: [{family: "", familyEn: "", familyLtn: "", name: "", nameEn: "", nameLtn: "", size: {size: "", sizeName: ""}}],
            results: [],
            selectedResult: {},
            mainImage: resim,
            family: "",

        }
        this.changeMultiple = this.changeMultiple.bind(this)
    }

    async componentDidMount() {
        const values = queryString.parse(this.props.location.search)
        const results = await getCall("/resultCicekGaleri/getallFront", { values })
        let motherInfo = results.data.sonucCicek.length === 0 ? [{family: "", familyEn: "", familyLtn: "", name: "", nameEn: "", nameLtn: "", yaprakTip: {typeName: ""}, shape: {typeName: ""}}] : results.data.sonucCicek
        let mainImage = results.data.sonucCicek.length === 0 ? this.state.mainImage : baseUrl + results.data.sonucCicek[0].shape.image
        await this.setState({ results: results.data.sonucBitkiGaleri, motherInfo: motherInfo, mainImage: mainImage})
    }

    async changeMultiple(val, selected) {
        if (val)
            await this.setState({ multiple: val, bannerMargin: undefined })
        else
            await this.setState({ selectedResult: selected, multiple: val, bannerMargin: 0 })
    }


    render() {
        return (
            <CardContainer>
                <CardHolder>
                    <ResultBanner
                        family={this.state.motherInfo[0].family}
                        familyEn={this.state.motherInfo[0].familyEn}
                        familyLtn={this.state.motherInfo[0].familyLtn}
                        resultName={this.state.motherInfo[0].name}
                        resultNameEn={this.state.motherInfo[0].nameEn}
                        resultNameLtn={this.state.motherInfo[0].nameLtn}
                        size={this.state.motherInfo[0].size.size}
                        sizeCm={this.state.motherInfo[0].size.sizeName}
                        image={this.state.mainImage}
                        bannerMargin={this.state.bannerMargin}
                    />
                    {this.state.multiple
                        ?
                        this.state.results.map((r, index) => {
                            return (
                                <Card key={index} openImage={() => this.changeMultiple(false, r)} image={baseUrl + r.image} name={this.state.motherInfo[0].name} />
                            )
                        })
                        :
                        <React.Fragment>
                            <div class="spesific-result-single-container">
                                <i onClick={() => this.changeMultiple(true)} class="fas fa-arrow-alt-circle-left" style={{ display: "block" }}></i>
                                <img src={baseUrl + this.state.selectedResult.image} alt={"selected"} class="selected-result-img"></img>
                            </div>
                        </React.Fragment>
                    }

                </CardHolder>
            </CardContainer>
        )
    }
}

export default ResultCardsExample
